import adsApi from '../ads-request/ads-api';
import LOGIN_CONSTANTS from '../../store/login-constants';

export default {
  methods: {
    async getOrderDetail(isAuthView = false, orderStatus = null) {
      try {
        const { success, data, message } = await adsApi.orderDetail(this.email, this.$session.get('superOrderId'));

        if (!success) {
          this.isErrorLogin = true;
          this.errorMessageLogin = message ?? LOGIN_CONSTANTS.ERROR;
          return;
        }

        if (data.orders.length === 0) {
          this.notFoundOrders = true;
          throw new Error('No se encontraron ordenes');
        }

        this.getDataAdviser(data.orders);
        this.setOrderDetailSession(data);

        if (isAuthView) {
          const brand = this.$session.get('brand') !== '' ? this.$session.get('brand') : process.env.VUE_APP_BRAND;
          this.$session.set('orderStatus', orderStatus ?? data.superOrderStatus);
          this.$store.commit('SET_LAYOUT', `${brand[0].toUpperCase()}${brand.substring(1)}Layout`);
          this.$router.push({ name: 'home' });
        } else {
          this.$store.commit('SET_LAYOUT', this.getEnvironmentLayoutName());
          this.$router.push({ name: 'home' });
        }
      } catch (error) {
        this.error = error;
      }
    },

    setOrderDetailSession(data) {
      const sessionMappings = {
        cellphoneContact: data.cellphoneContact,
        customerAddress: data.customerAddress,
        customerIdDMS: data.customerIdDMS,
        customerName: data.customerName,
        customerPhone: data.customerPhone,
        customerPhoneCode: data.customerPhoneCode,
        customerRFC: data.customerRFC,
        dealerAddress: data.dealerDireccion,
        dealerCity: data.dealerCiudad,
        dealerId: data.dealerId,
        dealerIdExt: data.dealerIdExt,
        dealerName: data.dealerName,
        dealerState: data.dealerEstado,
        emailContact: data.emailContact,
        model: data.model,
        nameContact: data.nameContact,
        orderComments: data.orderComments,
        orderId: data.superOrderId,
        orderIdDMS: data.superOrderIdDMS,
        orders: data.orders,
        orderStatus: data.superOrderStatus,
        plates: data.plates,
        receptionKilometers: data.receptionKilometers,
        showActivitiesList: false,
        showAdditionalBudgets: false,
        showPreInvoice: false,
        showTutorial: this.showTutorial,
        year: data.years,
      };

      Object.entries(sessionMappings).forEach(([key, value]) => {
        this.$session.set(key, value);
      });

      localStorage.setItem('dealerId', data.dealerId);
      localStorage.setItem('orderIdDMS', data.orders[0].orderIdDMS);
      localStorage.setItem('ordersLogin', JSON.stringify(data.orders));
      localStorage.setItem('originAuth', true);
      localStorage.setItem('parentSuperOrder', data.parentSuperOrderIdDMS);
      localStorage.setItem('parentSuperOrderId', data.parentSuperOrderId);

      if (data.parentSuperOrderId !== null) {
        localStorage.setItem('isParentOrder', true);
      } else {
        localStorage.setItem('isParentOrder', false);
      }
    },

    getDataAdviser(orders) {
      const orderReception = orders.filter((item) => item.orderAdviserName !== null
        && item.orderAdviserEmail !== null);
      this.$session.set('adviserName', orderReception.length > 0 ? orderReception[0].orderAdviserName : '');
      this.$session.set('adviserCellphone', orderReception.length > 0 ? orderReception[0].orderAdviserCellphone : '');
      this.$session.set('adviserEmail', orderReception.length > 0 ? orderReception[0].orderAdviserEmail : '');
      this.$session.set('observations', orderReception.length > 0 ? orderReception[0].orderObservations : '');
    },
  },
};
